import { createReactRenderer } from 'helpers/react-renderer';
import get from 'lodash/get';

import ManualPaymentModal from './components/manual-payment/ManualPaymentModal';

// eslint-disable-next-line
let _manualPaymentModal = null;

export default class ManualPayment {
  static doManualPayment(amount, saleManager, paymentProvider) {
    const contact = saleManager.customer ? saleManager.customer.get('Contact') : {};
    const cardHolderName = saleManager.customer ? saleManager.customer.fullName : '';

    const RenderedComponent = createReactRenderer({
      component: ManualPaymentModal,
      selector: '[data-react-root="ReactModal"]',
      props: {
        onHide: () => {
          _manualPaymentModal = null;
          RenderedComponent.unmount();
        },
        onDone: () => {
          // eslint-disable-next-line no-undef
          window.App.channel.vent.trigger(window.App.globalEvents.register.SHOW_PAYMENTS);
          _manualPaymentModal = null;
          RenderedComponent.unmount();
        },
        amount,
        balance: saleManager.pendingBalance,
        orderID: get(saleManager, 'sale.id'),
        customerID: get(saleManager, 'customer.id'),
        postalCode: get(contact, 'Addresses.ContactAddress.zip'),
        cardHolderName,
        saleManager,
        paymentProvider,
      },
    });
    _manualPaymentModal = RenderedComponent.mount();
  }
}
